import { atom } from "jotai";

import { contactRelationsSchema } from "../schemas/relation";
import { addressBookApi } from "../services";
import type { RelationLink } from "../types";

export const relationsAtom = atom<RelationLink[]>([]);

export const relationsLoadingAtom = atom(false);

export const relationsFailedAtom = atom(false);

/** Whose relations `relationsAtom` currently holds, to fetch each contact once. */
const loadedContactIdAtom = atom<number | null>(null);

export const loadRelationsAtom = atom(
  null,
  async (get, set, contactId: number) => {
    if (get(loadedContactIdAtom) === contactId || get(relationsLoadingAtom)) {
      return;
    }

    set(relationsLoadingAtom, true);
    set(relationsFailedAtom, false);

    try {
      const payload = await addressBookApi.fetchContactRelations(contactId);

      set(relationsAtom, contactRelationsSchema.parse(payload).links);
      set(loadedContactIdAtom, contactId);
    } catch (e) {
      console.error("Failed to load contact relations:", e);

      set(relationsAtom, []);
      set(relationsFailedAtom, true);
      set(loadedContactIdAtom, null);
    } finally {
      set(relationsLoadingAtom, false);
    }
  },
);
